import { gql } from '@apollo/client';

export const GET_LIST_LICENSES = gql`
  query GetList($where: Map, $sort: Map, $offset: Int, $limit: Int) {
    GetLicenseList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on Licenses {
        data {
          id
          user_type
          name
          description
          notes
          monthly_price
          annual_price
          biennial_price
          max_team_member
          max_socmed_account
          active_status
          created_at
          updated_at
          deleted_at
        }
      }
    }
  }
`;

export const GET_LICENSE_BY_ID = gql`
  query GetByID($id: String!) {
    list: GetLicenseByID(id: $id) {
      id
      user_type
      name
      description
      notes
      monthly_price
      annual_price
      biennial_price
      max_team_member
      max_socmed_account
      active_status
      created_at
      updated_at
      deleted_at
    }
  }
`;
